<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar dense color="grey lighten-4" flat>
        <v-icon>mdi-format-list-bulleted</v-icon>
        <v-toolbar-title class="body-2"
          >Claimant / Claim Item: {{ selectedClaimantClmtNo }} - {{ selectedClaimantClmtName }} / Item {{ selectedClmItemNo }}</v-toolbar-title
        >
      </v-toolbar>
      <v-card>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-toolbar-title class="toolbar-title-3">List of Outstanding Payment/Receipt</v-toolbar-title>
          <v-spacer />
          <v-btn class="mr-2" color="primary" @click.native="addPaymentHeader(true, null)">
            <span>New Payment</span>
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <template v-slot:activator="{ on }">
              <v-btn color="secondary" class="white--text" v-on="on">
                <span>Columns</span>
                <v-icon right dark>mdi-table-column-plus-after</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox
                    v-for="column in columns"
                    :key="column.value"
                    :label="column.text"
                    :value="column.value"
                    v-model="selectedColumns"
                  ></v-checkbox>
                </template>
                <template v-else>No column found</template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-toolbar>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs12 sm3>
                      <v-text-field :label="filtersLabel.name" single-line hide-details v-model="filters.name"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <v-autocomplete
                        v-model="filters.tranType1"
                        :items="tranTypeList1"
                        :label="filtersLabel.tranType1"
                        item-text="label"
                        item-value="value"
                        data-vv-name="tranType1"
                        :data-vv-as="filtersLabel.tranType1"
                        :error-messages="errors.collect('tranType1')"
                      />
                    </v-flex>
                    <v-flex xs12 sm3>
                      <v-text-field :label="filtersLabel.docNo" single-line hide-details v-model="filters.docNo"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="listHeaders"
              :items="items"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
               :key="items.length"
            >
              <template v-slot:item="row"
                ><tr>
                  <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      :custom="canReview(row)"
                      customIcon="mdi-select"
                      customText="Select"
                      @custom="addPaymentHeader(false, row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
    </v-card>
    <v-spacer class="mt-2"></v-spacer>
    <v-layout row wrap>
      <v-btn color="secondary" type="submit" @click.prevent="doBack">
        <span>Back</span>
        <v-icon right dark>mdi-arrow-left-bold-box</v-icon>
      </v-btn>
    </v-layout>
    <confirm-auth v-model="promptAuth" @ok="doAuthPendClmPayt('Approve')" @cancel="doAuthPendClmPayt('Reject')" yes-label="Yes" no-label="No"><div style="white-space: pre-line">{{ authTxt }}</div></confirm-auth>
      <v-dialog v-model="promptCaptureAuth" width="500px" persistent>
        <CaptureAuth @close="doCloseEnterPassword" @init="fetchData(true)" @updateRecord="updateAfterAuth" @cancel="doCloseEnterPassword" :clmNo="this.commonInfo.clmNo" :screen="false" :del="false"></CaptureAuth>
      </v-dialog>
      <v-dialog v-model="promptCaptureAuthDel" width="500px" persistent>
        <CaptureAuth @close="doCloseEnterPassword" @updateRecord="doDelPendClmPayt" @cancel="doCloseEnterPassword" :clmNo="this.commonInfo.clmNo" :screen="false" :del="true"></CaptureAuth>
      </v-dialog>
      <confirm-auth v-model="promptAuthApproveTxt" @ok="doBack" yes-label="Cancel" :info="true">{{ authApproveTxt }}</confirm-auth>
  </v-container>
</template>

<script>
import clone from 'clone'
import { listMixin } from '@/mixins/listMixin'
import { ClaimCommonMixin } from '@/mixins/claim/ClaimCommonMixin'
import { CLAIMS_LIFECYCLE, CLAIMS_CLAIMPAYMENT_SELECTEDRESERVES } from '@/store/types'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'
import { commonMixins } from '@/mixins/common/commonMixin'
import CaptureAuth from '@/components/core/claimManagement/CaptureAuth'
import ConfirmAuth from '@/components/core/claimManagement/ConfirmAuth'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
export default {
  props: {
    selectedReserve: {
      type: Array,
      default: () => []
    }
  },
  components: {
    CaptureAuth,
    ConfirmAuth
  },
  data() {
    return {
      columns: [
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'Fund', align: 'left', value: 'fund' },
        { text: 'Transaction Type', align: 'left', value: 'tranTypeDesc' },
        { text: 'Document No.', align: 'left', value: 'docNo' },
        { text: 'Status', align: 'left', value: 'status' },
        { text: 'Transaction Date', align: 'left', value: 'tranDateFormat' },
        { text: 'Payee Account No.', align: 'left', value: 'payeeAcctNo' },
        { text: 'Payee Name', align: 'left', value: 'name' },
        { text: 'Currency', align: 'left', value: 'curr' }
      ],
      selectedColumns: ['name', 'tranTypeDesc', 'docNo', 'status', 'tranDateFormat', 'branch', 'fund'],
      filters: {
        branch: undefined,
        tranType1: undefined,
        docNo: undefined,
        tranDate: undefined,
        payeeAcctNo: undefined,
        name: undefined,
        curr: undefined
      },
      claimPayment: {
        selectedReserve: []
      },
      filtersLabel: {
        branch: 'Branch',
        tranType1: 'Transaction Type',
        docNo: 'Document No.',
        tranDate: 'Transaction Date',
        payeeAcctNo: 'Payee Account No.',
        name: 'Payee Name',
        curr: 'Currency'
      },
      totalItems: 1,
      pagination: {
        sortDesc: [true],
        page: 1,
        itemsPerPage: 5
      },
      promptAuth: false,
      promptCaptureAuth: false,
      promptCaptureAuthDel: false,
      authTxt: '',
      authApproveTxt: 'User Not Authorised to Approve Transaction',
      promptAuthApproveTxt: false
    }
  },
  computed: {
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    selectedClaimant() {
      return this.claimDetail.selectedClaimant || {}
    },
    selectedClmItem() {
      return this.claimDetail.selectedClmItem || {}
    },
    commonInfo() {
      return this.claimDetail.commonInfo
    },
    currencyList() {
      return this.$store.state.claims.claimParams.currencyList
    },
    branchList() {
      return this.$store.state.claims.claimParams.branchList
    },
    selectedClaimantClmtName() {
      if (this.selectedClaimant.clmtName) {
        return this.selectedClaimant.clmtName
      } else {
        return 'Claimant'
      }
    },
    selectedClaimantClmtNo() {
      if (this.selectedClaimant.clmtNo) {
        return (this.selectedClaimant.clmtNo + '').padStart(3, '0')
      } else {
        return '000'
      }
    },
    selectedClmItemNo() {
      if (this.selectedClmItem.clmItem) {
        return this.selectedClmItem.clmItem
      } else {
        return '0'
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    getCurrencyParam(key) {
      for (let paramCurrency of this.currencyList) {
        if (paramCurrency.value === key) {
          return paramCurrency
        }
      }
      return {}
    },
    getBranchParam(key) {
      for (let param of this.branchList) {
        if (param.value === key) {
          return param
        }
      }
      return {}
    },
    async fetchData(option) {
      this.promptCaptureAuth = false
      this.promptCaptureAuthDel = false
      await this.checkUsrClmLim().then((x) => {
        this.doPromptAuth(x)
      })
      const apiUrl = this.claimDetail.menu.paymentHeaders
      this.loading = true
      if (apiUrl) {
        try {
          let massageFilters = clone(this.filters)
          if (massageFilters.tranDate) {
            massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
          }
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          if (this.docNo) {
            massageFilters.docNo = this.docNo
          }
          if (this.name) {
            massageFilters.name = this.name
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            this.loading = false
            this.items = []
            data.map((element) => {
              const item = {
                acctMth: element.acctMth,
                acctNoSfx: element.acctNoSfx,
                acctYr: element.acctYr,
                addr1: element.addr1,
                addr2: element.addr2,
                addr3: element.addr3,
                addr4: element.addr4,
                bankAcctCurr: element.bankAcctCurr !== '' ? element.bankAcctCurr : '-',
                bankChrg: element.bankChrg,
                bankChrgLoc: element.bankChrgLoc,
                bankCurrAmt: element.bankCurrAmt,
                bankNo: element.bankNo + ' - ' + element.bankNoDesc,
                bankTotLoc: element.bankTotLoc,
                bankTotLocAe: element.bankTotLocAe,
                branch: element.branch,
                cashBkNo: element.cashBkNo,
                cheque: element.cheque,
                clmClsd: element.clmClsd,
                cseStat: element.cseStat,
                curr: element.curr,
                deemGst: element.deemGst,
                dept: element.dept,
                docNo: element.docNo,
                docNoAe: element.docNoAe,
                docPrtd: element.docPrtd,
                drawerName: element.drawerName,
                exRate: element.exRate,
                fund: element.fund,
                gstAmt: element.gstAmt,
                gstAmtLoc: element.gstAmtLoc,
                gstRegNo: element.gstRegNo,
                gstStat: element.gstStat,
                inOutGst: element.inOutGst,
                name: element.name,
                name2: element.name2,
                netAmt: element.netAmt,
                netAmtLoc: element.netAmtLoc,
                payBank: element.payBank,
                payChqNo: element.payChqNo,
                payInSlipNo: element.payInSlipNo,
                payInsd: element.payInsd,
                payeeAcctNo: element.payeeAcctNo,
                paytAmt: element.paytAmt,
                paytAmtLoc: element.paytAmtLoc,
                paytAmtTax: element.paytAmtTax,
                paytAmtTaxLoc: element.paytAmtTaxLoc,
                postCode: element.postCode,
                prtClmPv: element.prtClmPv,
                prtClmtName: element.prtClmtName,
                prtCseLoss: element.prtCseLoss,
                prtLossDesc: element.prtLossDesc,
                riRcvyCurr: element.riRcvyCurr,
                stmtRef: element.stmtRef,
                taxInv: element.taxInv,
                titleName: element.titleName,
                tranDate: new Date(element.tranDate),
                tranRel: element.tranRel,
                tranType1: element.tranType1,
                tranTypeDesc: this.getItemValue(element.tranType1, this.tranTypeList1).label,
                // currDesc: this.getCurrencyParam(element.curr).label,
                currDesc: element.curr + ' - ' + element.currDesc,
                tranDateFormat: this.formatDateTime2(new Date(element.tranDate)),
                // branchDesc: this.getBranchParam(element.branch).label,
                branchDesc: element.branch + ' - ' + element.branchDesc,
                clmPays: element.clmPays,
                status: element.status
              }
              this.items.push(item)
            })
          } else {
            this.loading = false
            this.items = []
          }
        } catch (err) {
          this.loading = false
          this.items = []
        }
      } else {
        this.loading = false
        this.items = []
      }
    },
    doClearFilters() {
      // Iterate through each object field, key is name of the object field
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined
      })
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    addPaymentHeader(newHeader, row) {
      let header = {
        newHeader: newHeader
      }
      if (row) {
        header = {
          newHeader: newHeader,
          selectedHeader: row
        }
      }
      this.$store.commit(CLAIMS_CLAIMPAYMENT_SELECTEDRESERVES, header)
      this.$router.push({ name: 'claimPayment' })
    },
    canReview(row) {
      if (row.item.tranRel !== true) {
        return true
      }
      return false
    },
    async doBack() {
      this.back = true
      this.$store.commit(CLAIMS_LIFECYCLE, 5)
      this.$store.commit('UPDATE_CLM_PEND_EXIST_LIST', {
        updateById: {
          clmNo: this.clmNo,
          docNo: this.docNo
        }
      })
      this.$router.push({ name: 'claimReserve', params: { navFlag: 1 } })
    },
    async checkUsrClmLim() {
      try {
        const apiUrl = this.$store.state.commons.menu.checkUsrClmLimPayt
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result.data.data
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async doPromptAuth(data) {
      if (data.result === true && data.pendList) {
        let authContent = 'There is a claim payment pending authorisation:\n'
        for (const item of data.pendList) {
          authContent += `- (${item.branch}, ${item.tranType1}, ${item.docNo}, ${item.fund}, SGD ${formatDisplayNumber(item.paytAmtLoc, 2)})\n`
        }
        authContent += 'Proceed to authorise?'
        this.authTxt = authContent
        this.promptAuth = true
        this.firstEnterScreen = false
      }
    },
    async doAuthPendClmPayt(action) {
      try {
        const apiUrl = this.$store.state.commons.menu.authPendClmPayt
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.data.result === true) {
            if (action === 'Approve') {
              this.promptCaptureAuth = true
            } else if (action === 'Reject') {
              this.promptCaptureAuthDel = true
            }
          } else {
            this.usrClmLim = false
            this.promptAuthApproveTxt = true
          }
          return result.data.data.result
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async validDelPassword() {
      this.promptCaptureAuthDel = true
    },
    async doCloseEnterPassword() {
      this.promptCaptureAuth = false
      this.promptCaptureAuthDel = false
      this.promptAuth = true
    },
    async doDelPendClmPayt() {
      try {
        const apiUrl = this.$store.state.commons.menu.delPendClmPayt
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          this.items = this.items.filter(
            item => item.status !== 'P'
          )
          this.commonInfo.clmPayts = this.commonInfo.clmPayts.filter(
            item => item.status !== 'P'
          )
          return result
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
      this.fetchData(true)
    },
    async updateAfterAuth() {
      this.promptCaptureAuth = false
      this.promptCaptureAuthDel = false
      let paytAmt = 0
      let paytAmtLoc = 0
      let clmResCat = null
      this.commonInfo.clmPayts.forEach(item => {
        if (item.status === 'P') {
          item.status = ''
          paytAmt = item.paytAmt
          paytAmtLoc = item.paytAmtRes
          clmResCat = item.clmResCat
        }
      })
      this.commonInfo.clmAccumRes.forEach(item => {
        if (clmResCat != null && clmResCat === item.clmResCat) {
          item.planned = parseFloat(removeFormatNumber(item.planned)) + parseFloat(removeFormatNumber(paytAmt))
          item.plannedRes = parseFloat(removeFormatNumber(item.plannedRes)) + parseFloat(removeFormatNumber(paytAmt))
          item.plannedLoc = parseFloat(removeFormatNumber(item.plannedLoc)) + parseFloat(removeFormatNumber(paytAmtLoc))
        }
      })
      this.commonInfo.totPlannedRes = this.commonInfo.totPlannedRes + parseFloat(removeFormatNumber(paytAmt))
      this.commonInfo.totPlanned = this.commonInfo.totPlanned + parseFloat(removeFormatNumber(paytAmt))
      this.commonInfo.totPlannedLoc = this.commonInfo.totPlannedLoc + parseFloat(removeFormatNumber(paytAmtLoc))
    }
  },
  mounted() {
    if (this.claimDetail.claimLifeCycle !== 6) {
      this.$store.commit(CLAIMS_LIFECYCLE, 6)
    }
    this.fetchData(true)
  },
  created() {
    if (this.claimDetail.init !== 1) {
      this.$store.dispatch('claimEntryInit')
    }
  },
  mixins: [listMixin, ClaimCommonMixin, commonMixins]
}
</script>

<style>
</style>
